import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {Company} from '../models/company';

export const companyActionTypes = {
  LOAD: type('[Company] Load'),
  LOAD_SUCCESS: type('[Company] Load Success'),
  LOAD_FAIL: type('[Company] Load Fail'),
  CLEAR: type('[Company] Clear'),
};

export class LoadCompanyAction implements Action {
  readonly type = companyActionTypes.LOAD;
  constructor(public payload?: string) {}
}

export class LoadCompanySuccessAction implements Action {
  readonly type = companyActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Company) {}
}

export class LoadCompanyFailAction implements Action {
  readonly type = companyActionTypes.LOAD_FAIL;
  constructor(public payload?: number) {}
}

export class CompanyClearAction implements Action {
  readonly type = companyActionTypes.CLEAR;
  constructor() {}
}


